import { tryOnScopeDispose as r } from "./index599.js";
function m() {
  let t;
  const o = (i, n) => {
    e(), t = window.setTimeout(i, n);
  }, e = () => window.clearTimeout(t);
  return r(() => e()), {
    registerTimeout: o,
    cancelTimeout: e
  };
}
export {
  m as useTimeout
};
